import { render, staticRenderFns } from "./DisablePromoCodeForm.vue?vue&type=template&id=0683d698"
import script from "./DisablePromoCodeForm.vue?vue&type=script&lang=ts"
export * from "./DisablePromoCodeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports